import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class PositiveThemeService {

	isPositiveTheme: boolean;

	constructor() { }

	getIsPositiveTheme(): boolean {
		return this.isPositiveTheme;
	}

	setIsPositiveTheme(isPositive: boolean): void {
		this.isPositiveTheme = isPositive;
	}

}
